import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export type ScheduleType = 'flexible' | 'fixed'

const SCHEDULE_TYPE = Object.freeze({
  flexible: 'flexible',
  fixed: 'fixed',
})

interface IOverlapPeriod {
  id: string
  default: boolean
  schedule_id: string
  start_date: string
  end_date: string
  schedule_type: ScheduleType
}

class OverlapPeriod extends Model<IOverlapPeriod> {
  constructor(attr: IOverlapPeriod) {
    super(attr)
    makeObservable(this, {
      isFixed: computed,
    })
  }

  static urlRoot() {
    return '/work_schedule/overlap_periods'
  }

  get isFixed(): boolean {
    return this.attributes.schedule_type === SCHEDULE_TYPE.fixed
  }
}

export default OverlapPeriod
